/** Fields a diary can switch off for patient collection. Add a case to `isFieldCollected` for each new one. */
export type CollectableField = "hospital_number";

/**
 * Whether the patient should be asked for this field on this diary.
 * Hidden fields keep any stored value; this only controls collection and display.
 */
export function isFieldCollected(
    diary: { require_hospital_number?: boolean | null },
    field: CollectableField
): boolean {
    switch (field) {
        case "hospital_number":
            // Explicit false skips; true or undefined (stale payload) still collects.
            return diary.require_hospital_number !== false;
    }
}
